import { useRouter } from 'vue-router';
import { onMounted, nextTick } from "vue";
import { WOW } from 'wowjs';
import "animate.css";
export default {
  name: "DevelopmentHistory",
  setup: function setup() {
    var router = useRouter();
    onMounted(function () {
      //初始化wow.js(页面滚动加载动画)
      nextTick(function () {
        //页面渲染完，在执行
        var wow = new WOW({
          live: false
        });
        wow.init();
      });
    });
    return {};
  }
};